/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IconProps } from '../types';

type IconPropsExtended = IconProps;

export const LocationIcon = ({
  className,
  ...otherProps
}: IconPropsExtended): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="LocationIcon"
    role="img"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={classNames('cogs-icon', className)}
    {...otherProps}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.75 1.32 1.753 5.65l-.056.023a1.092 1.092 0 0 0-.014 1.978l4.442 2.222 2.222 4.442a1.092 1.092 0 0 0 2-.07L14.68 2.251a.73.73 0 0 0-.007-.521.72.72 0 0 0-.924-.41m-.957 1.886-9.73 3.515L6.99 8.685c.14.07.254.184.324.324l1.964 3.929z"
      clipRule="evenodd"
    />
  </svg>
);
